<template>
  <v-container
    fill-height
    fluid
    class="deals-wrapper"
  >
    <v-layout
      xs12
      justify-center
      wrap
    >
      <v-flex
        md5
      >
        <h2>{{ $t('transactions.transactions') }}</h2>
      </v-flex>
      <v-flex
        md7
        xs12
        mb-0
        mt-0
        :class="!$vuetify.breakpoint.xs ? 'pt-5 text-right': 'pt-0'"
        pb-0
        text-right
      >
        <v-text-field
          v-model.trim="search"
          name="search"
          max-length="100"
          style="width:220px"
          prepend-inner-icon="mdi-text-box-search-outline"
        >
          <template v-slot:append>
            <v-icon
              v-if="search"
              style="cursor:pointer"
              @click="search = ''"
            >
              mdi-close
            </v-icon>
          </template>
        </v-text-field>
      </v-flex>

      <v-flex
        v-if="whiteLabelTransactions && !_.isEmpty(whiteLabelTransactions.data)"
        xs12
      >
        <v-card>
          <v-data-table
            class="text-no-wrap deals-table"
            :headers="headers"
            :items="whiteLabelTransactions.data"
            :server-items-length="whiteLabelTransactions.total"
            :items-per-page="params.count"
            :page="params.page"
            :mobile-breakpoint="900"
            :footer-props="{
              'items-per-page-options': [10, 15, 25, 50, 100, 200]
            }"
            @update:options="loadTransactions"
          >
            <template v-slot:item.user="{ item }">
              <v-layout
                wrap
              >
                <v-flex
                  md3
                  xs4
                  mt-4
                  mb-1
                >
                  <v-avatar
                    v-if="item.user.avatar != null"
                    :tile="false"
                    :size="30"
                  >
                    <v-img
                      :src="item.user.avatar"
                      :lazy-src="item.user.avatar"
                      max-height="30"
                      contain
                    />
                  </v-avatar>
                  <v-avatar
                    v-else
                    :tile="false"
                    :size="30"
                    :color="$vuetify.theme.dark ? $vuetify.theme.themes.dark.background : $vuetify.theme.themes.light.background"
                  >
                    <strong>
                      <a style="cursor: default;">{{ item.user.name | uppercase | substring(0,2) }}</a>
                    </strong>
                  </v-avatar>
                </v-flex>
                <v-flex
                  md9
                  xs8
                  mt-2
                  mb-2
                >
                  <small><b>{{ item.user.name }}</b><br>
                    {{ item.user.email }}</small>
                </v-flex>
              </v-layout>
            </template>
            <template #item.created_at="{ item }">
              {{ item.created_at | moment("L LT") }}
            </template> 
            <template #item.payment_subject="{ item }">
              <small>{{ $t("transactions." + item.payment_subject) }}</small>
            </template>
            <template #item.note="{ item }">
              <small v-html="searchEmail(item.note)" />
            </template>
            <template #item.amount_in="{ item }">
              <b>{{ item.amount_in ? item.amount_in : item.amount_out ? `-${item.amount_out}` : '0' }} {{ item.currency }}</b>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
      <v-flex
        v-if="whiteLabelTransactions && _.isEmpty(whiteLabelTransactions.data) && !loading"
        xs12
      >
        <v-card>
          <v-flex
            xs-12
            class="not-found"
          >
            <v-icon>mdi-ghost</v-icon>
            <p>{{ $t('transactions.notFound') }}</p>
          </v-flex>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import WHITELABEL_TRANSACTIONS_QUERY from '@/graphql/queries/WhiteLabelTransactions.gql';
import {mapGetters} from "vuex";

export default {
  name: "Transactions",
  data(){
    return {
      loading:true,
      search: '',
      params: {
        whitelabel_uuid: null,
        page: 1,
        count: 25,
        search: ''
      },
      headers:[
        {
          sortable: false,
          text: this.$t('transactions.user'),
          value: 'user',
        },
        {
          sortable: false,
          text: this.$t("transactions.date"),
          value: "created_at",
        },
        {
          sortable: false,
          text: this.$t("transactions.type"),
          value: "payment_subject",
        },
        {
          sortable: false,
          text: this.$t("transactions.description"),
          value: "note",
        },
        {
          sortable: false,
          text: this.$t("transactions.summ"),
          value: "amount_in",
        },
      ],
      transactions: []
    }

  },
  computed:{
    ...mapGetters("whitelabel", ["getWhiteLabel"]),
  },
  watch:{
    getWhiteLabel(val) {
      this.params.whitelabel_uuid = val.uuid
      this.$apollo.queries.whiteLabelTransactions.refetch()
    },
    search() {
      this.reload();
    },
  },
  mounted() {
    if (this.getWhiteLabel) {
      this.params.whitelabel_uuid = this.getWhiteLabel.uuid
    }
  },
  methods:{
    async loadTransactions({ page, itemsPerPage }){
      this.loading = true;
      this.params.count = itemsPerPage;
      this.params.page = page;
      await this.$apollo.queries.whiteLabelTransactions.fetchMore({
        variables: this.params,
        updateQuery: (previousResult, { fetchMoreResult }) => {
          return fetchMoreResult;
        },
      });
      this.loading = false;
    },
    async reload(value, from, nextPage = false) {
      this.loading = true
      if(!nextPage){
        this.params.page = 1;
      }
      this.params[from] = value

      if (this.search) {
        if (this.search.length < 2) {
          return
        }
        this.params.search = this.search
      } else {
        delete(this.params.search)
      }
      await this.$apollo.queries.whiteLabelTransactions.fetchMore({
        variables: this.params,
        updateQuery: (previousResult, { fetchMoreResult }) => {
          return fetchMoreResult
        },
      });
      this.loading = false
    },
    searchEmail(val) {
      const re = /(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()\.,;\s@\"]+\.{0,1})+([^<>()\.,;:\s@\"]{2,}|[\d\.]+))/;
      if (re.test(val)) {
        let newString = val;
        const findEmail = re.exec(val);
        newString = newString.replace(
          `${findEmail[0]}`,
          `<a
            href="mailto:${findEmail[0]}"
            style="color: var(--primary-color); font-weight: 600;"
          >
            ${findEmail[0]}
          </a>`
        );
        return newString;
      }

      return val;
    },
  },
  apollo: {
    whiteLabelTransactions: {
      query: WHITELABEL_TRANSACTIONS_QUERY,
      fetchPolicy: 'network-only',
      variables() {
        return this.params
      },
      result({loading}) {
        this.loading = loading
      },
      skip() {
        return !this.params.whitelabel_uuid
      }
    },
  }
}
</script>

<style lang="scss" >
.deals{
  &-viewMode-btn{
    cursor:pointer;
  }
  &-table-name{
    font-weight: 600;
    color: var(--color-primary-text);
    cursor:pointer
  }
  &-wrapper{
    .v-data-table > .v-data-table__wrapper > table {
      border-spacing: 0 .5rem;
    }
    .v-data-table td {
      padding-bottom: 4px !important;
    }
  }
}
</style>
